import { Box, Flex, Text } from '@chakra-ui/react';
import { HeadingPages } from '../../../components/HeadingPages';
import { AtualizarPedidoPago, LimpezaCache } from './Options';
import { AtualizarPesoTGFCAB } from './Options/AtualizarPesoTGFCAB';
import { BaixarNota } from './Options/BaixarNota';
import { BaixarXml } from './Options/BaixarXml';
import { CancelarFilaLayout } from './Options/CancelarFilaLayout';
import { FecharPedidoKangu } from './Options/FecharPedidoKangu';
import { GerarBoletoManualmente } from './Options/GerarBoletoManualmente';
import { VerificacaoProdutos } from './Options/VerificacaoProdutos';
import { RemoverBaixaPedido } from './Options/RemoverBaixaPedido';
import { BaixaManual } from './Options/BaixaManual';
import { ListarTabelas } from './Options/ListarTabelas';

export function RotinasFrequentes() {
  return (
    <>
      <HeadingPages name="Rotinas Frequentes" />
      <Box maxW="1280px" w="full" px="1rem" py=".5rem" mx="auto">
        <Text textAlign="center" fontSize="2rem" fontWeight="semibold">
          O que você deseja fazer?
        </Text>

        <Flex flexWrap="wrap" w="full" gap="1rem" mt="1rem">
          <LimpezaCache />
          <AtualizarPedidoPago />
          <AtualizarPesoTGFCAB />
          <BaixarNota />
          <BaixarXml />
          <CancelarFilaLayout />
          <VerificacaoProdutos />

          <FecharPedidoKangu />
          <GerarBoletoManualmente />
          <RemoverBaixaPedido />
          <BaixaManual />
          <ListarTabelas />
        </Flex>
      </Box>
    </>
  );
}
